<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{parentdata.title}}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
<image-cropper [imageChangedEvent]="imageChangedEvent" style="max-height:400px" [maintainAspectRatio]="true" [imageQuality]="92" [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="2 / 2" [resizeToWidth]="256" [cropperMinWidth]="128"
[onlyScaleDown]="true" [roundCropper]="true" [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'center'"  format="png" (imageCropped)="imageCropped($event)"
(imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"></image-cropper>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    (click)="onSave()"
      mat-flat-button
      color="accent">
    Save
    </button>
  </mat-dialog-actions>